// zoe - kk - 2024

try {

    const addToCartButton = document.querySelector('[data-action="add-to-cart"]');


    if (addToCartButton) {


        addToCartButton.addEventListener('click', function (event) {
            if (isTShirt) {
                event.preventDefault();

                const dropdown = document.querySelector('.dropdown-button');
                const dropdownValue = dropdown.textContent;

                
                

                var items = [
                    {
                        id: freePrint.get(dropdownValue), // Variant ID for the first product
                        quantity: getQuantityInput(),
                        properties: {
                            "Product": variant_selected_or_first.name
                        }
                    },
                    {
                        id: variant_selected_or_first.id, // Variant ID for the second product
                        quantity: getQuantityInput(),
                    }
                ];


                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ items: items })
                })
                    .then(response => response.json())
                    .then(cartData => {
                        console.log('Product added to cart:', cartData);
                        // Optionally update the cart UI or perform other actions
                         window.location.href = '/cart';

                    })
                    .catch(error => {
                        console.error('Error adding product to cart:', error);
                    });
            }
        });
    }




    // Optional: Add an event listener for the custom event to handle it elsewhere
    document.addEventListener('cartUpdated', function (event) {
        console.log('Custom event received:', event.detail.message);
        // Handle the event as needed, e.g., show a notification or update UI

    });



    document.addEventListener("DOMContentLoaded", function () {

        const url = new URL(window.location.href);
        const pathname = url.pathname;
        const productHandle = pathname.split('/')[2];

        if (productHandle) {
            fetch(`/products/${productHandle}.js`)
                .then(response => response.json())
                .then(data => {

                    if (data.tags.includes("T-Shirt")) {
                        isTShirt = true;
                    } else {
                        isTShirt = false;
                    }
                })
                .catch(error => {
                    //console.error("Error fetching product data:", error);
                });
        } else {
            //console.error("Product handle is not available.");
        }
    });



    document.addEventListener('variant:changed', function (event) {
        const newVariant = event.detail.variant;
        // console.log('New variant:', newVariant);

        updateQuantityInput(initialQuantity, true);
        //document.querySelector('.dropdown-container').innerHTML = initalDropdownHTML;
       // document.querySelector('.checkbox-section').innerHTML = initalCheckboxHTML;
        //document.getElementById('uploadContainer').innerHTML = initalUploadHTML;

        document.querySelector('.dropdown-container').reset();
        document.querySelector('.checkbox-section').reset();
        document.getElementById("uploadContainer").reset();


        //document.location.reload();
    });

    document.addEventListener('DOMContentLoaded', function () {

        if (window.location.pathname.includes('/cart')) {
            // Check if this is the first page load
            if (!sessionStorage.getItem('cartPageLoaded')) {
                // Set the flag in sessionStorage
                sessionStorage.setItem('cartPageLoaded', 'true');


                // Reload the page
                window.location.reload();
            } else {
                // Remove the flag after the page reloads to avoid further reloads
                sessionStorage.removeItem('cartPageLoaded');
            }
        }

    });


    // slider fallback
    document.addEventListener('DOMContentLoaded', function () {



        var slider = document.getElementById('quantity-slider');

        // Create a temporary element to detect the slider's track color
        var testTrack = document.createElement('div');
        testTrack.style.position = 'absolute';
        testTrack.style.visibility = 'hidden';
        document.body.appendChild(testTrack);

        // Check for WebKit or Firefox styles
        var trackVisible = false;

        // Test for WebKit
        testTrack.style.backgroundColor = getComputedStyle(slider, '::-webkit-slider-runnable-track').backgroundColor;
        if (testTrack.style.backgroundColor !== 'rgba(0, 0, 0, 0)' && testTrack.style.backgroundColor !== '') {
            trackVisible = true;
        }

        // Test for Firefox
        testTrack.style.backgroundColor = getComputedStyle(slider, '::-moz-range-track').backgroundColor;
        if (testTrack.style.backgroundColor !== 'rgba(0, 0, 0, 0)' && testTrack.style.backgroundColor !== '') {
            trackVisible = true;
        }

        // Apply fallback if track is not visible
        if (!trackVisible) {
            slider.classList.add('fallback');
        }

        document.body.removeChild(testTrack); // Clean up the temporary element
    });


    document.addEventListener('DOMContentLoaded', function () {




        var saleLabel = document.querySelector('.product-label.product-label--on-sale');

        if (typeof makeCartQuantity === 'function') {
            makeCartQuantity();
        }


        if (window.location.pathname.includes('/products/')) {

            try {
                initalDropdownHTML = document.querySelector('.dropdown-container').innerHTML;
                initalCheckboxHTML = document.querySelector('.checkbox-section').innerHTML;
                initalImageUploadHTML = document.getElementById('uploadContainer').innerHTML;
                
            } catch (error) {
                
            }


            if (saleLabel && saleLabel.offsetParent !== null) {
                isProductOnSale = true;
                document.querySelector('.spacing').style.visibility = 'visible';
                document.querySelector('.price-summary').style.display = 'none'; // Hide price-summary
            } else {
                isProductOnSale = false;
                document.querySelector('.spacing').style.visibility = 'hidden'; // Hide spacing
                document.querySelector('.price-summary').style.display = 'block'; // Show price-summary
            }


            //by default
            let isUsingGroupedTag = false;
            groupedTag = '';
            const slider = document.getElementById('quantity-slider');
            totalPriceElement = document.querySelector('.totalprice-value');
            totalSavingsElement = document.querySelector('.totalsavings-line');


            slider.min = 1;
            slider.value = 1;
            slider.max = 5000;

            const pathParts = window.location.pathname.split('/');

            const productHandle = pathParts[pathParts.length - 1];

            fetch(window.Shopify.routes.root + 'products/' + productHandle + '.js')
                .then(response => response.json())
                .then(product => {

                    const tagsInfo = product.tags;
                    //console.log('Tags:', tagsInfo);

                    const minTagPattern = /^MIN(\d+)/;
                    const minTag = tagsInfo.find(tag => minTagPattern.test(tag));
                    if (minTag) {
                        const minMatch = minTag.match(minTagPattern);
                        if (minMatch) {
                            initialQuantity = parseInt(minMatch[1], 10);
                            console.log('initialQuantity on set:', initialQuantity);
                            const quantityInput = document.querySelector('.quantity-selector__value');
                            quantityInput.value = initialQuantity;
                            slider.min = initialQuantity;
                            slider.value = initialQuantity;
                            slider.max = 5000;
                            totalPrice = (initialQuantity * initPrice).toFixed(2);
                            totalSavings = (0).toFixed(2);
                            setUrlParam('quantity', initialQuantity);
                            // console.log('Total price:', totalPrice);
                            totalPriceElement.textContent = '$' + totalPrice;
                            totalSavingsElement.textContent = 'Save $' + totalSavings;

                          // updateQuantityInput(slider.value, true);
                          // setUrlParam('quantity', slider.value);

                          setTimeout(() => {
                            quantityInput.value = initialQuantity;
                          },1000)

                          let price_per_item = parseFloat(document.getElementById('unit-price').innerText.replace('$',''))
                          let total_price = price_per_item * quantityInput.value

                          document.getElementById('total-price').innerHTML = `Total price: <span>$${total_price.toFixed(2)}</span>`
                        }
                    }


                    // Extract the first number from tags with the format ~_number
                    const tagPattern = /^~_(\d+)/;
                    const tag = tagsInfo.find(tag => tagPattern.test(tag));
                    if (tag) {
                        const match = tag.match(tagPattern);
                        if (match) {
                            //console.log(match.input);
                            isUsingGroupedTag = true;
                            groupedTag = match.input;

                            const foundOffer = findOfferByCampaignName(groupedTag);
                            //console.log("using grouped tag: ", groupedTag);
                            if (foundOffer) {
                                discountRule = foundOffer.discount_rule;
                                if (foundOffer.discount_rule[0].discount_unit === 'percent') {

                                    if (typeof calculatePrecentage === 'function') {
                                        calculatePrecentage();
                                    }
                                    //console.log("using precentage discount");
                                }


                                //console.log('Discount rules:', discountRule);
                            } else {
                                //console.log("Offer not found");
                            }

                        }
                    } else {
                        const targetCampaignName = document.title;
                        // console.log(targetCampaignName);
                        const foundOffer = findOfferByCampaignName(targetCampaignName);
                        if (foundOffer) {
                            discountRule = foundOffer.discount_rule;
                            if (foundOffer.discount_rule[0].discount_unit === 'percent') {
                                if (typeof calculatePrecentage === 'function') {
                                    calculatePrecentage();
                                }
                                //console.log("using precentage discount");
                            }
                            //console.log('Discount rules:', discountRule);
                        } else {
                            //console.log("Offer not found");
                        }
                    }
                });
          

            
            // let priceText = document.querySelector('.price').innerText;
            let priceText = document.getElementById('unit-price').innerText;
            let match = priceText.match(/\$([\d.]+)/); // Extract the price from the text

            if (match) {
                initPrice = parseFloat(match[1]);
                //console.log('Initial price (float):', initPrice);
            } else {
                //console.log('Price could not be extracted.');
            }

            const decreaseButton = document.querySelector('[data-action="decrease-picker-quantity"]');
            const increaseButton = document.querySelector('[data-action="increase-picker-quantity"]');


            function handleEnterKey(event) {
                if (event.key === 'Enter') { // Check if Enter key is pressed
                    const quantityInput = document.querySelector('.quantity-selector__value');
                    let temp = parseFloat(quantityInput.value);
                    if (quantityInput.value < initialQuantity) {
                        quantityInput.value = initialQuantity;
                    }
                    if (typeof checkDiscount === 'function') {
                        checkDiscount(temp);
                    }
                    event.preventDefault();
                    const scaledFunctionThingyMaBobber = (((Math.pow((1.464*(temp-initialQuantity))/(5000-initialQuantity),1/4))-0.1)*(5000-initialQuantity))+initialQuantity;
                    //console.log(scaledFunctionThingyMaBobber);
                    updateQuantityInput(scaledFunctionThingyMaBobber);
                    slider.value = scaledFunctionThingyMaBobber;

                  updateSliderTrack()

                  let price_per_item = parseFloat(document.getElementById('unit-price').innerText.replace('$',''))
                  let total_price = price_per_item * quantityInput.value
    
                  document.getElementById('total-price').innerHTML = `Total price: <span>$${total_price.toFixed(2)}</span>`
                }
            }

            // Add event listener to the input field
            let quantityI = document.querySelector('.quantity-selector__value');
            quantityI.addEventListener('keydown', handleEnterKey);


            increaseButton.addEventListener('click', () => {
                console.log("increase");
                const quantityInput = document.querySelector('.quantity-selector__value');
                //console.log('Increase button clicked');
                //updateQuantityInput(parseFloat(quantityInput.value), true);
                let temp = parseFloat(quantityInput.value);
                temp++;
                const scaledFunctionThingyMaBobber = (((Math.pow((1.464*(temp-initialQuantity))/(5000-initialQuantity),1/4))-0.1)*(5000-initialQuantity))+initialQuantity;
                console.log(scaledFunctionThingyMaBobber);
                updateQuantityInput(scaledFunctionThingyMaBobber);
                slider.value = scaledFunctionThingyMaBobber;
                //console.log(slider.value, quantityInput.value, sliderQuantity);
                if (typeof checkDiscount === 'function') {
                    checkDiscount(temp);
                }

              updateSliderTrack()

              let price_per_item = parseFloat(document.getElementById('unit-price').innerText.replace('$',''))
              let total_price = price_per_item * quantityInput.value

              document.getElementById('total-price').innerHTML = `Total price: <span>$${total_price.toFixed(2)}</span>`
            });


            decreaseButton.addEventListener('click', () => {
              console.log("decrease");
                const quantityInput = document.querySelector('.quantity-selector__value');
                let temp = parseFloat(quantityInput.value);
    
                // Check if the current value is greater than the initial quantity
                if (temp > initialQuantity) {
                    temp--
                } else {
                    quantityInput.value = initialQuantity; // Keep the value at the initialQuantity
                    temp = initialQuantity;
                }
                
                const scaledFunctionThingyMaBobber = (((Math.pow((1.464*(temp-initialQuantity))/(5000-initialQuantity),1/4))-0.1)*(5000-initialQuantity))+initialQuantity;
                console.log(scaledFunctionThingyMaBobber);
                updateQuantityInput(scaledFunctionThingyMaBobber);
                slider.value = scaledFunctionThingyMaBobber;
                
                if (typeof checkDiscount === 'function') {
                    checkDiscount(temp);
                }

              updateSliderTrack()
                
                event.preventDefault();

              let price_per_item = parseFloat(document.getElementById('unit-price').innerText.replace('$',''))
              let total_price = price_per_item * quantityInput.value

              document.getElementById('total-price').innerHTML = `Total price: <span>$${total_price.toFixed(2)}</span>`
            });


            if (typeof resetPrice === 'function') {
                resetPrice();// really hack fix for always having element as .newprice
            }

            const tooltip = document.getElementById('slider-tooltip');

            function updateTooltip() {
                const value = sliderQuantity;
                tooltip.textContent = value;

                const thumbWidth = 32; // Width of the slider thumb
                const sliderWidth = slider.offsetWidth;
                let percentage = ((Math.pow((((1.464) * (sliderQuantity - initialQuantity)) / (slider.max - initialQuantity)), (1 / exponent))) - 0.1);;
                if (percentage < -0.01) {
                    percentage = -0.01;
                }
                //console.log(percentage);
                //console.log("exponent", Math.pow(sliderQuantity, exponent));
                //console.log(initialQuantity + (slider.max - initialQuantity) * Math.pow(sliderQuantity, exponent))
                const thumbOffset = percentage * (sliderWidth - thumbWidth);
                tooltip.style.left = `${thumbOffset + thumbWidth / 2}px`; // Center the tooltip on the thumb
            }

            slider.addEventListener('input', () => {
                if (slider.value < initialQuantity) {
                    slider.value = initialQuantity; // Ensure slider value is not below the initial quantity
                    //console.log(slider.value);
                }
                tooltip.style.display = 'block'; // Show the tooltip while sliding
                updateTooltip();

                quantityInput = document.querySelector('.quantity-selector__value');
                let price_per_item = parseFloat(document.getElementById('unit-price').innerText.replace('$',''))
                let total_price = price_per_item * quantityInput.value
  
                document.getElementById('total-price').innerHTML = `Total price: <span>$${total_price.toFixed(2)}</span>`
            });

            slider.addEventListener('change', () => {
                if (slider.value < initialQuantity) {
                    slider.value = initialQuantity; // Ensure slider value is not below the initial quantity
                }
                tooltip.style.display = 'none'; // Hide the tooltip when sliding stops

                updateSliderTrack()

                quantityInput = document.querySelector('.quantity-selector__value');
                let price_per_item = parseFloat(document.getElementById('unit-price').innerText.replace('$',''))
                let total_price = price_per_item * quantityInput.value
  
                document.getElementById('total-price').innerHTML = `Total price: <span>$${total_price.toFixed(2)}</span>`

            });




            //const variantId = document.querySelector('[name="id"]').value;
            //addCustomProductToCart('50150546342162');
            //console.log('Product page variant ID:', variantId);

            if (typeof updateQuantityInput === 'function') {
                updateQuantityInput(slider.value, true);
                setUrlParam('quantity', slider.value);
            }

            //console.log(slider.min);
        }
    });
} catch (err) {
    console.log(`%cError:%c ${err}`, 'color: #D12E67; font-weight: bold;', 'color: White;');
}

function findOfferByCampaignName(campaignName) {
    try {
        return omgQuantityData.offers.find(offer => offer.campaign_name === campaignName);
    } catch (err) {
        console.log(`%cError:%c ${err}`, 'color: #D12E67; font-weight: bold;', 'color: White;');
    }
}


function waitForElement(selector, callback) {
    try {
        const interval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(interval);
                callback(element);
            }
        }, 100); // Check every 100 milliseconds
    } catch (err) {
        console.log(`%cError:%c ${err}`, 'color: #D12E67; font-weight: bold;', 'color: White;');
    }
}





function setUrlParam(name, value) {
    let url = new URL(window.location.href);
    url.searchParams.set(name, value);
    window.history.pushState({}, '', url);
}

function getUrlParam(param) {
    let url = new URL(window.location.href);
    return url.searchParams.get(param);
}




const inputRange = document.getElementById("quantity-slider");
const activeColor = "#339933";
const inactiveColor = "#dddddd";

inputRange.addEventListener("input", function() {
  updateSliderTrack()
});

inputRange.addEventListener("change", function() {
  updateSliderTrack()
});

function updateSliderTrack() {
  const ratio = (inputRange.value - inputRange.min) / (inputRange.max - inputRange.min) * 100;
  inputRange.style.background = `linear-gradient(90deg, ${activeColor} ${ratio}%, ${inactiveColor} ${ratio}%)`;  
}